import type { ApiMission, MissionKind, MissionMode } from '../../shared/types';
import { get, patch, post, remove } from '../../shared/api/http';

export interface MissionTierInput { threshold: number; qty: number; }

export interface MissionInput {
  key: string;
  kind: MissionKind;
  labelEs: string;
  labelPt: string;
  descriptionEs?: string;
  descriptionPt?: string;
  active?: boolean;
  mode?: MissionMode;
  unitValue?: number;
  maxPerEvent?: number | null;
  tiers?: MissionTierInput[];
}

/** Missões: a regra que transforma uma ação do jogador em cartelas. */
export const missionsApi = {
  list: (): Promise<ApiMission[]> => get('/missions'),
  create: (input: MissionInput): Promise<ApiMission> => post('/missions', input),
  update: (id: string, input: Partial<Omit<MissionInput, 'key'>> & { position?: number }): Promise<ApiMission> => patch(`/missions/${id}`, input),
  remove: (id: string): Promise<void> => remove(`/missions/${id}`),
};
